const doc = [({"ja":({"japan":"日本", "mediterranean":"地中海", "scandinavia":"北欧", "northAmerica":"北米", "asia":"アジア", "tokyo":"東京", "osaka":"大阪", "nagoya":"名古屋"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;